<template>
  <b-modal ref="modal-dkkd" title="Merchant có đăng kí kinh doanh không?">
    <div>
      <span class="text-red">*</span><i>Có: Ghi nhận merchant có đăng đăng kí kinh doanh</i>
      <br />
      <span class="text-red">*</span><i>Không: Ghi nhận merchant không có đăng kí kinh doanh</i>
    </div>
    <template #modal-footer>
      <div class="d-flex justify-content-end">
        <b-button variant="danger" @click="handleApprove(false)">Không</b-button>
        <b-button class="ml-2" variant="success" @click="handleApprove(true)">Có</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: 'DkkdModal',
    props: {
      contractId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {}
    },
    methods: {
      hide() {
        this.$refs['modal-dkkd'].hide()
      },
      show() {
        this.$refs['modal-dkkd'].show()
      },
      handleApprove(option) {
        this.$emit('approve', {
          hasBusinessRegistrationNumber: option,
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .text-red {
    color: red;
  }
</style>
